/* おすすめカニ診断 v2 (recommend-quiz-v2)
 * - 採点ロジックの正は scripts/quiz-v2/simulate.mjs。係数・規則を変える時は両方を更新する
 * - 回答状態は URL の ?a=(v2キーのカンマ列、設問順)。リロード/共有/メール直リンクで再現可能
 * - 商品データは #quiz-feed(全active商品+蟹種マスタ)。表示直前に /products/{handle}.js で在庫再検証
 * - 解禁待ち枠は既存の入荷通知モーダル([data-notify-trigger])に接続。戻りURLのクエリ保持は
 *   notify-signup.js の withMbParams が担保する(?a= が生き残る)
 */
(() => {
  const root = document.getElementById('quiz-v2');
  const feedEl = document.getElementById('quiz-feed');
  if (!root || !feedEl) return;

  let FEED;
  try {
    FEED = JSON.parse(feedEl.textContent);
  } catch (e) {
    return;
  }

  const DEBUG = new URLSearchParams(location.search).get('mb_debug') === '1';
  const publish = (name, payload) => {
    if (DEBUG) return; // QAのテスト完走で本番統計を汚さない(仕様§7)
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {
      /* 計測失敗で機能を止めない */
    }
  };

  /* ── 定数(simulate.mjsと同値) ─────────────────────────── */
  const FRESHNESS = { asadore: 1.0, live: 0.9, boiled: 0.55, frozen: 0.35 };
  const COST_FLOOR = 1;
  // v1メタオブジェクトのoption_handle → v2キー + レーダー用加点(f=鮮度/v=サイズ/c=コスパ)
  const OPTION_MAP = {
    purpose: {
      home: { k: 'home', f: 1, v: 1 },
      gift: { k: 'gift', f: 2, v: 1 },
    },
    recipe: {
      kanisashi: { k: 'sashi', f: 3 },
      kanishabunabe: { k: 'shabu', f: 2 },
      yudekani: { k: 'yude', f: 1 },
      grill: { k: 'grill', f: 1 },
      default: { k: 'undecided' },
    },
    importance_characteristics: {
      kanimios: { k: 'miso', f: 1 },
      volume: { k: 'kanimi', v: 3 },
      uchicosotoko: { k: 'chinmi' },
      kanimosoandkanimi: { k: 'both', f: 1, v: 2 },
      zenbu: { k: 'all', f: 1, v: 3, c: -1 },
    },
    important_point: {
      sendo: { k: 'fresh', f: 5, c: -1 },
      cooking_easy: { k: 'boiled' },
      brand: { k: 'brand', f: 3, c: -2 },
      cospa: { k: 'cospa', c: 5 },
      nashi: { k: 'none' },
    },
    people_num: {
      '1to2': { k: '1-2' },
      '3to4': { k: '3-4', v: 1 },
      '5plus': { k: '5plus', v: 3 },
      default: { k: 'undecided' },
    },
    budget: {
      u30: { k: 'u30' },
      b30_50: { k: 'b30_50' },
      b50plus: { k: 'b50plus' },
      tbd: { k: 'tbd' },
    },
  };
  // 「予算をひとつ上げる」の遷移チェーン(未定は対象外)
  const BUDGET_RELAX = ['u30', 'b30_50', 'b50plus'];

  /* ── 採点(simulate.mjs移植) ───────────────────────────── */
  const buildWeights = (a) => {
    const w = { fresh: 0, size: 0, cost: COST_FLOOR, tasteKey: null, tasteW: 0 };
    const c = { hardCond: null, gift: false, tierBoost: null, partsPref: null, target: null, cap: null, decayFrom: null };

    if (a.purpose === 'home') { w.fresh += 1; w.size += 1; }
    if (a.purpose === 'gift') { w.fresh += 2; w.size += 1; c.gift = true; }

    if (a.recipe === 'sashi') { w.fresh += 3; c.hardCond = ['live', 'asadore']; }
    if (a.recipe === 'shabu') { w.fresh += 2; c.partsPref = ['shoulder']; }
    if (a.recipe === 'yude') { w.fresh += 1; }
    if (a.recipe === 'grill') { w.fresh += 1; c.partsPref = ['shoulder']; }

    if (a.importance_characteristics === 'kanimi') { w.size += 3; w.tasteKey = 'kanimi'; w.tasteW = 3; }
    if (a.importance_characteristics === 'miso') { w.fresh += 1; w.tasteKey = 'miso'; w.tasteW = 3; }
    if (a.importance_characteristics === 'chinmi') { w.tasteKey = 'chinmi'; w.tasteW = 3; }
    if (a.importance_characteristics === 'both') { w.fresh += 1; w.size += 2; w.tasteKey = 'miso'; w.tasteW = 3; }
    if (a.importance_characteristics === 'all') { w.fresh += 1; w.size += 3; w.cost -= 1; w.tasteKey = 'all'; w.tasteW = 3; }

    if (a.important_point === 'fresh') { w.fresh += 5; w.cost -= 1; }
    if (a.important_point === 'boiled' && a.recipe !== 'sashi') { c.requireCooked = true; } // 調理済み=ボイル+ボイル済み冷凍(冷凍タラバ等)
    if (a.important_point === 'brand') { w.fresh += 3; w.cost -= 2; c.tierBoost = 'premium'; }
    if (a.important_point === 'cospa') { w.cost += 5; c.tierBoost = 'value'; }

    if (a.people_num === '1-2') c.target = [1, 2.5];
    if (a.people_num === '3-4') { w.size += 1; c.target = [2.5, 4]; }
    if (a.people_num === '5plus') { w.size += 3; c.target = [3.5, 99]; }

    // 帯境界はサイト予算コレクションと同一((下限,上限]・ちょうど額は下の帯)。
    // 下限は採点に使わない(帯は「上限」の意思として解釈。仕様§5.1)
    if (a.budget === 'u30') c.cap = 30000;
    if (a.budget === 'b30_50') c.cap = 50000;
    if (a.budget === 'b50plus') c.decayFrom = 100000; // 上限なし帯の暴走防止(帯下限×2)
    if (a.budget === 'tbd') c.decayFrom = 60000; // 未定=青天井ではなく中庸デフォルト(中央値38kの1.6倍)
    w.cost = Math.max(0, w.cost);
    return { w, c };
  };

  const validProduct = (p) => p.sp && FEED.species[p.sp] && p.smin != null && p.c;

  const scoreProduct = (p, wc, bestPpl) => {
    const { w, c } = wc;
    const sp = FEED.species[p.sp];
    if (c.cap && p.p > c.cap) return null;
    if (c.gift && p.dl) return null; // ギフト×日時指定不可は原則除外
    if (c.hardCond && c.hardCond.indexOf(p.c) === -1) return null;
    if (c.requireCooked && !p.ck) return null; // 調理済み指定(仕様§5.1)

    const mid = (p.smin + p.smax) / 2;
    const taste = w.tasteKey === 'all'
      ? Math.max(sp.kanimi, sp.miso, sp.chinmi) / 3
      : w.tasteKey ? sp[w.tasteKey] / 3 : 0;
    let score =
      w.fresh * FRESHNESS[p.c] +
      w.size * Math.min(mid / 3.5, 1) +
      w.tasteW * taste +
      w.cost * (bestPpl / (p.p / mid));

    if (c.tierBoost && p.tier === c.tierBoost) score += 1;
    if (c.partsPref && c.partsPref.indexOf(p.parts) !== -1) score += 0.8;
    if (c.gift && p.tier === 'value') score *= 0.5; // ギフト×訳ありは大幅減点
    if (c.decayFrom && p.p > c.decayFrom) score *= c.decayFrom / p.p;

    let note = '';
    if (c.target) {
      const lo = c.target[0];
      const hi = c.target[1];
      if (p.smax >= lo && p.smin <= hi) {
        /* 適合 */
      } else if (p.smax * 2 >= lo && p.smin * 2 <= hi) {
        score *= 0.85;
        note = '×2個で' + lo + '名〜に対応';
      } else {
        score *= 0.7;
      }
    }
    score += sp.boost || 0;
    return { score, note };
  };

  const rank = (wc, ignoreStock) => {
    const pool = FEED.products.filter((p) => validProduct(p) && (ignoreStock || p.a));
    if (!pool.length) return [];
    const bestPpl = Math.min.apply(null, pool.map((p) => p.p / ((p.smin + p.smax) / 2)));
    const bySpecies = {};
    pool.forEach((p) => {
      const s = scoreProduct(p, wc, bestPpl);
      if (!s) return;
      (bySpecies[p.sp] = bySpecies[p.sp] || []).push(Object.assign({}, p, { score: s.score, note: s.note }));
    });
    return Object.keys(bySpecies)
      .map((sp) => {
        const prods = bySpecies[sp].sort((a, b) => b.score - a.score);
        const top = prods.slice(0, 2);
        return { sp, speciesScore: top.reduce((s, p) => s + p.score, 0) / top.length, products: prods };
      })
      .sort((a, b) => b.speciesScore - a.speciesScore);
  };

  // 調理状態のハードフィルタが空結果の原因になりうる回答(空結果・解禁待ちの文言出し分けに使用)
  const condCause = (answers) => {
    if (answers.important_point === 'boiled') {
      return { label: '茹で/味付け済み', relabel: '調理済みの指定を外して再診断', q: 'important_point', opt: 'nashi', k: 'none' };
    }
    if (answers.recipe === 'sashi') {
      return { label: 'お刺身向きの活', relabel: 'かに刺しの指定を外して再診断', q: 'recipe', opt: 'default', k: 'undecided' };
    }
    return null;
  };

  const diagnose = (answers) => {
    const wc = buildWeights(answers);
    const inStock = rank(wc, false);
    const ignoring = rank(wc, true);
    const inStockSp = {};
    inStock.forEach((s) => { inStockSp[s.sp] = true; });
    // 在庫無視ランキング上位3以内の最上位在庫ゼロ種を解禁待ちに(仕様§5.1)
    let wait = null;
    ignoring.slice(0, 3).some((s, i) => {
      if (!inStockSp[s.sp]) { wait = { sp: s.sp, rank: i + 1 }; return true; }
      return false;
    });
    return { primary: inStock[0] || null, alternatives: inStock.slice(1, 3), wait, inStock };
  };

  /* ── 在庫再検証(表示分のみ。キャッシュ由来の売切表示防止・仕様§10) ── */
  const recheckAvailability = (handles) => {
    const timeout = new Promise((resolve) => setTimeout(() => resolve(null), 1200));
    return Promise.all(handles.map((h) =>
      Promise.race([
        fetch('/products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null),
        timeout,
      ]).then((data) => (data && data.available === false ? h : null))
    )).then((soldOut) => soldOut.filter(Boolean));
  };

  /* ── DOM ─────────────────────────────────────────────── */
  const $ = (sel) => root.querySelector(sel);
  // 設問順はDOMから導出(メタオブジェクト側の設問増減に追従し、属性との二重管理を避ける)
  const steps = {};
  const order = [];
  root.querySelectorAll('[data-step]').forEach((el) => {
    steps[el.dataset.question] = el;
    order.push(el.dataset.question);
  });
  if (!order.length) return; // qa_list未設定(セクションがエラー文言を表示済み)
  const quizStage = $('[data-quiz-stage]');
  const loadingStage = $('[data-loading-stage]');
  const resultStage = $('[data-result-stage]');

  const state = { answers: {}, labels: {}, lockUntil: 0, started: false }; // answers: question→v2キー / labels: 表示用

  const keyToOption = (question, key) => {
    const map = OPTION_MAP[question] || {};
    const opt = Object.keys(map).filter((o) => map[o].k === key)[0];
    return opt || null;
  };

  const encodeUrl = () => {
    const parts = order.map((q) => state.answers[q]).filter(Boolean);
    const url = new URL(location.href);
    if (parts.length) url.searchParams.set('a', parts.join(','));
    else url.searchParams.delete('a');
    history.replaceState({}, '', url.pathname + url.search + url.hash);
  };

  const decodeUrl = () => {
    const raw = new URLSearchParams(location.search).get('a');
    if (!raw) return;
    raw.split(',').forEach((key, i) => {
      const q = order[i];
      if (!q) return;
      const opt = keyToOption(q, key);
      if (!opt) return;
      state.answers[q] = key;
      const btn = steps[q] && steps[q].querySelector('[data-option="' + opt + '"]');
      state.labels[q] = btn ? btn.textContent.trim() : key;
    });
  };

  const answeredCount = () => order.filter((q) => state.answers[q]).length;

  const showStep = (question) => {
    quizStage.hidden = false;
    loadingStage.hidden = true;
    resultStage.hidden = true;
    $('[data-sticky]').hidden = true;
    order.forEach((q) => { if (steps[q]) steps[q].hidden = q !== question; });
    const idx = order.indexOf(question);
    $('[data-step-now]').textContent = idx + 1;
    $('[data-progress]').style.width = ((idx) / order.length) * 100 + '%';
    $('[data-back]').hidden = idx === 0;
    // 矛盾回答の構造的防止: かに刺し選択時はQ4の「茹で/味付け済み」を出さない(仕様§5.1)
    if (question === 'important_point') {
      const btn = steps.important_point.querySelector('[data-option="cooking_easy"]');
      if (btn) btn.hidden = state.answers.recipe === 'sashi';
    }
  };

  const nextUnanswered = () => order.filter((q) => !state.answers[q])[0] || null;

  /* ── 結果レンダリング ─────────────────────────────────── */
  const yen = (n) => '¥' + Number(n).toLocaleString('ja-JP');
  const servText = (p) => (p.smin === p.smax ? p.smin + '人前' : p.smin + '〜' + p.smax + '人前');

  const productCard = (p) => {
    const li = document.createElement('li');
    li.className = 'qz-card';
    li.innerHTML =
      '<a href="' + p.u + '" target="_blank" rel="noopener" data-quiz-product="' + p.h + '">' +
      '<span class="qz-card__media">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') + '</span>' +
      '<span class="qz-card__title"></span>' +
      '<span class="qz-card__serv"></span>' +
      '<span class="qz-card__price">' + yen(p.p) + '<small>税込</small></span>' +
      '</a>';
    li.querySelector('.qz-card__title').textContent = p.t;
    li.querySelector('.qz-card__serv').textContent = servText(p) + (p.note ? ' — ' + p.note : '');
    return li;
  };

  const drawRadar = (el, vals) => {
    // vals = {fresh, cost, size} (基準50+加点、v1互換。軸最大80)
    const R = 78;
    const cx = 130;
    const cy = 96;
    const angles = [-90, 150, 30]; // 鮮度(上)/コスパ(左下)/サイズ(右下)
    const pt = (deg, r) => {
      const rad = (deg * Math.PI) / 180;
      return (cx + r * Math.cos(rad)).toFixed(1) + ',' + (cy + r * Math.sin(rad)).toFixed(1);
    };
    const axisVals = [vals.fresh, vals.cost, vals.size];
    const poly = angles.map((a, i) => pt(a, (Math.min(axisVals[i], 80) / 80) * R)).join(' ');
    const grid = [0.33, 0.66, 1].map((k) =>
      '<polygon points="' + angles.map((a) => pt(a, R * k)).join(' ') + '" fill="none" stroke="rgba(18,18,18,.1)"/>'
    ).join('');
    const labels = ['鮮度', 'コスパ', 'サイズ'];
    const labelPos = [[cx, 14], [cx - 84, cy + 46], [cx + 84, cy + 46]];
    el.innerHTML =
      '<svg width="260" height="196" viewBox="0 0 260 196" role="img" aria-label="' +
      labels.map((l, i) => l + axisVals[i]).join(' ') + 'のレーダーチャート">' + grid +
      '<polygon points="' + poly + '" fill="rgba(199,177,131,.5)" stroke="#8a7350" stroke-width="1"/>' +
      labels.map((l, i) =>
        '<text x="' + labelPos[i][0] + '" y="' + labelPos[i][1] + '" text-anchor="middle" font-size="12" fill="#1a1a1a">' +
        l + ' <tspan fill="#8a7350">' + axisVals[i] + '</tspan></text>'
      ).join('') + '</svg>';
  };

  const radarValues = () => {
    let f = 0;
    let v = 0;
    let cc = 0;
    order.forEach((q) => {
      const opt = keyToOption(q, state.answers[q]);
      const m = opt && OPTION_MAP[q][opt];
      if (!m) return;
      f += m.f || 0;
      v += m.v || 0;
      cc += m.c || 0;
    });
    const clamp = (n) => Math.max(0, Math.min(100, 50 + n));
    return { fresh: clamp(f), size: clamp(v), cost: clamp(cc) };
  };

  const speciesBlock = (entry, count) => {
    const sp = FEED.species[entry.sp];
    const wrap = document.createElement('div');
    wrap.className = 'qz-alt';
    const h = document.createElement('h4');
    h.className = 'qz-alt__name';
    h.textContent = sp.name;
    wrap.appendChild(h);
    const ul = document.createElement('ul');
    ul.className = 'qz-grid qz-grid--alt';
    ul.setAttribute('role', 'list');
    entry.products.slice(0, count).forEach((p) => ul.appendChild(productCard(p)));
    wrap.appendChild(ul);
    return wrap;
  };

  const renderResult = (r) => {
    quizStage.hidden = true;
    loadingStage.hidden = true;
    resultStage.hidden = false;
    $('[data-progress]').style.width = '100%';

    const stockCount = FEED.products.filter((p) => validProduct(p) && p.a).length;
    const now = new Date();
    $('[data-result-meta]').textContent =
      '本日の在庫 ' + stockCount + '品から選定 — ' + now.getFullYear() + '.' + (now.getMonth() + 1) + '.' + now.getDate() + '時点';

    const cause = condCause(state.answers);
    const degraded = $('[data-degraded-zone]');
    const primaryZone = $('[data-primary-zone]');
    if (!r.primary) {
      degraded.hidden = false;
      primaryZone.hidden = true;
      $('[data-usertype]').textContent = '';
      // 調理状態指定が原因の空結果は原因を明示する(「種が欠品」と誤読させない)
      $('[data-headline]').textContent = cause
        ? '『' + cause.label + '』は本日すべて売切です'
        : '本日の在庫では、ぴったりの一杯が見つかりませんでした';
      const relaxCond = $('[data-relax-cond]');
      relaxCond.hidden = !cause;
      if (cause) relaxCond.textContent = cause.relabel;
      const relax = $('[data-relax-budget]');
      const bi = BUDGET_RELAX.indexOf(state.answers.budget);
      relax.hidden = !(bi > -1 && bi < BUDGET_RELAX.length - 1);
    } else {
      degraded.hidden = true;
      primaryZone.hidden = false;
      const sp = FEED.species[r.primary.sp];
      $('[data-usertype]').textContent = sp.usertype || '';
      $('[data-headline]').textContent = 'おすすめは『' + sp.name + '』';
      const grid = $('[data-primary-grid]');
      grid.textContent = '';
      r.primary.products.slice(0, 6).forEach((p) => grid.appendChild(productCard(p)));
      const more = $('[data-primary-more]');
      if (sp.col_url) {
        more.hidden = false;
        more.href = sp.col_url;
        more.textContent = (sp.col_title || sp.name) + 'をもっと見る';
      } else {
        more.hidden = true;
      }
      // sticky CTA(モバイル)
      const sticky = $('[data-sticky]');
      const stickyLink = $('[data-sticky-link]');
      stickyLink.href = sp.col_url || (r.primary.products[0] && r.primary.products[0].u) || '#';
      stickyLink.textContent = sp.name + 'を見る';
      sticky.hidden = false;
    }

    const altsZone = $('[data-alts-zone]');
    const alts = $('[data-alts]');
    alts.textContent = '';
    if (r.alternatives.length) {
      altsZone.hidden = false;
      r.alternatives.forEach((entry) => alts.appendChild(speciesBlock(entry, 2)));
    } else {
      altsZone.hidden = true;
    }

    const waitZone = $('[data-wait-zone]');
    if (r.wait) {
      const sp = FEED.species[r.wait.sp];
      // 種としては在庫があるのに調理状態フィルタで落ちている場合、「種全体が欠品」と誤読させない
      const altStock = cause && FEED.products.some((p) => validProduct(p) && p.a && p.sp === r.wait.sp);
      waitZone.hidden = false;
      $('[data-wait-title]').textContent =
        r.wait.rank === 1 ? '本来のあなたの1位は、' + sp.name + '。' : '次の楽しみは、' + sp.name + '。';
      $('[data-wait-body]').textContent = altStock
        ? 'ご指定の『' + cause.label + '』が入荷待ちです。'
        : r.wait.rank === 1
          ? '在庫を気にしなければ総合1位。いまは入荷を待っています。'
          : 'あなたの回答と好相性の蟹。いまは入荷を待っています。';
      const seasonEl = $('[data-wait-season]');
      seasonEl.textContent = sp.season_note || '';
      seasonEl.hidden = !sp.season_note; // 空のままだと余白だけ残るため
      const notifyBtn = $('[data-wait-notify]');
      if (sp.col_handle) notifyBtn.setAttribute('data-notify-collection', sp.col_handle);
      else notifyBtn.removeAttribute('data-notify-collection');
      const altBtn = $('[data-wait-alt]');
      if (altStock && sp.col_url) {
        altBtn.hidden = false;
        altBtn.href = sp.col_url;
        altBtn.textContent = '本日購入できる' + sp.name + 'を見る';
      } else {
        altBtn.hidden = true;
      }
    } else {
      waitZone.hidden = true;
    }

    drawRadar($('[data-radar]'), radarValues());

    const chips = $('[data-chips]');
    chips.textContent = '';
    order.forEach((q) => {
      if (!state.labels[q]) return;
      const li = document.createElement('li');
      li.className = 'qz-chip';
      li.textContent = state.labels[q];
      chips.appendChild(li);
    });

    const guides = $('[data-guides]');
    guides.textContent = '';
    order.forEach((q) => {
      const opt = keyToOption(q, state.answers[q]);
      const tpl = opt && root.querySelector('template[data-guide-qa="' + q + '"][data-guide-opt="' + opt + '"]');
      if (tpl) guides.appendChild(tpl.content.cloneNode(true));
    });
    $('[data-guides-zone]').hidden = !guides.children.length;

    publish('mb_quiz_complete', {
      answers: order.map((q) => state.answers[q] || '').join(','),
      top_species: r.primary ? r.primary.sp : 'none',
      in_stock_count: stockCount,
      has_wait_species: Boolean(r.wait),
      wait_species: r.wait ? r.wait.sp : '',
    });
  };

  const finish = () => {
    quizStage.hidden = true;
    resultStage.hidden = true;
    loadingStage.hidden = false;
    const stockCount = FEED.products.filter((p) => validProduct(p) && p.a).length;
    $('[data-stock-count]').textContent = stockCount;

    const minWait = new Promise((resolve) => setTimeout(resolve, 900));
    let result = diagnose(state.answers);
    const displayHandles = []
      .concat(result.primary ? result.primary.products.slice(0, 6) : [])
      .concat(result.alternatives.reduce((acc, e) => acc.concat(e.products.slice(0, 2)), []))
      .map((p) => p.h);

    Promise.all([recheckAvailability(displayHandles), minWait]).then((res) => {
      const soldOut = res[0];
      if (soldOut.length) {
        FEED.products.forEach((p) => { if (soldOut.indexOf(p.h) !== -1) p.a = false; });
        result = diagnose(state.answers); // 売切判明分を除いて一度だけ再採点
      }
      renderResult(result);
    });
  };

  /* ── イベント ─────────────────────────────────────────── */
  root.addEventListener('click', (event) => {
    const optBtn = event.target.closest('.qz-opt');
    if (optBtn) {
      // 連打・ダブルタップで次の設問を誤答するのを防ぐ(ステップ切替直後のクリックを無視)
      if (Date.now() < state.lockUntil) return;
      state.lockUntil = Date.now() + 350;
      const stepEl = optBtn.closest('[data-step]');
      const q = stepEl.dataset.question;
      const map = OPTION_MAP[q] && OPTION_MAP[q][optBtn.dataset.option];
      if (!map) return;
      if (!state.started) { state.started = true; publish('mb_quiz_start', {}); }
      state.answers[q] = map.k;
      state.labels[q] = optBtn.textContent.trim();
      // かに刺し→茹で済みの矛盾防止: レシピを変えたらQ4の既存回答も見直す
      if (q === 'recipe' && map.k === 'sashi' && state.answers.important_point === 'boiled') {
        delete state.answers.important_point;
        delete state.labels.important_point;
      }
      publish('mb_quiz_answer', { question: q, option: map.k, step: order.indexOf(q) + 1 });
      encodeUrl();
      const next = nextUnanswered();
      if (next) showStep(next);
      else finish();
      return;
    }
    if (event.target.closest('[data-back]')) {
      const answered = order.filter((q) => state.answers[q]);
      const last = answered[answered.length - 1];
      if (!last) return;
      delete state.answers[last];
      delete state.labels[last];
      encodeUrl();
      showStep(last);
      return;
    }
    if (event.target.closest('[data-retry]')) {
      state.answers = {};
      state.labels = {};
      encodeUrl();
      showStep(order[0]);
      window.scrollTo({ top: root.offsetTop, behavior: 'auto' });
      return;
    }
    if (event.target.closest('[data-relax-cond]')) {
      const cause = condCause(state.answers);
      if (!cause) return;
      state.answers[cause.q] = cause.k;
      const btn = steps[cause.q] && steps[cause.q].querySelector('[data-option="' + cause.opt + '"]');
      state.labels[cause.q] = btn ? btn.textContent.trim() : cause.k;
      encodeUrl();
      finish();
      return;
    }
    if (event.target.closest('[data-relax-budget]')) {
      const bi = BUDGET_RELAX.indexOf(state.answers.budget);
      if (bi > -1 && bi < BUDGET_RELAX.length - 1) {
        state.answers.budget = BUDGET_RELAX[bi + 1];
        const opt = keyToOption('budget', state.answers.budget);
        const btn = steps.budget && steps.budget.querySelector('[data-option="' + opt + '"]');
        state.labels.budget = btn ? btn.textContent.trim() : state.answers.budget;
        encodeUrl();
        finish();
      }
      return;
    }
    const productLink = event.target.closest('[data-quiz-product]');
    if (productLink) {
      publish('mb_quiz_product_click', { handle: productLink.dataset.quizProduct });
    }
  });

  /* ── 起動 ─────────────────────────────────────────────── */
  decodeUrl();
  const next = nextUnanswered();
  if (!next) finish();
  else showStep(next);
})();
